const capitalizeFirstLetter = (string) => {
  if (!string) return '';

  return string[0].toUpperCase() + string.slice(1);
};

export { capitalizeFirstLetter }; // eslint-disable-line import/prefer-default-export



// WEBPACK FOOTER //
// ./src/helpers/text.js